import { Injectable } from '@angular/core'
import { Collection } from '../interfaces/collection.interface'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import {ColorService} from './color.service'


@Injectable()
export class ApiService {

  defaultOptions = {
    withCredentials: true
  }

  constructor(private http: HttpClient) { }

  getCollections() {
    return this.http
      .get(environment.apiBaseUrl + 'collection')
  }

  getCollection(id: number) {
    return this.http
      .get(environment.apiBaseUrl + `collection/${id}`, this.defaultOptions)
  }

  getCSSContent(id: number, dialect: string) {
    return this.http
      .get(environment.apiBaseUrl + `collection/${ id }/static?lang=${ dialect }`, {responseType: 'text'})
  }

  patchCollection(collection: Collection) {
    return this.http
      .patch(environment.apiBaseUrl + `collection/${collection.id}`, collection, this.defaultOptions)
      .subscribe()
  }

  postCollection(c: Collection) {
    return this.http
      .post(environment.apiBaseUrl + `collection`, c, this.defaultOptions)
  }

  deleteCollection(c: Collection) {
    return this.http
      .delete(environment.apiBaseUrl + `collection/${c.id}`, this.defaultOptions)
  }

  getStatistics(value: string, params?: any) {
    return this.http
      .get(environment.apiBaseUrl + `statistics`, { ...this.defaultOptions, params: { value, ...params } })
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/shared/services/api.service.ts